import { CriticalIllnessProductBackend } from "Components/Features/CheckPrice/Products/Advice/mappers/mapToCommerceCriticalIllness";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { isDefined } from "Utils/functions";
import { MappingData } from "./mapToCartProducts";

export const mapToCriticalIllnessProduct = (
  data: MappingData,
): CriticalIllnessProductBackend => {
  const insuredSum = data.priceFormData.criticalIllnessInsuredSumSlider;
  if (!isDefined(insuredSum)) {
    throw Error(
      "mapToCriticalIllnessProduct - cannot map to cart product - insured sum is not defined",
    );
  }
  return {
    name: INSURANCE_NAME_VALUE.CRITICAL_ILLNESS,
    coverageGroup: data.priceData[0].configurationName,
    dateOfBirth: data.customerData.newCustomerResponse.dateOfBirth ?? "",
    insuredSum,
    isFemale: data.customerData.newCustomerResponse.isFemale,
    isScandinavianCitizen: true,
    isSmoker: false,
    isStayingInNorwayForMoreThanFiveYears: true,
  };
};
